import { render, staticRenderFns } from "./SubMenuContainer.vue?vue&type=template&id=18d6a3de&scoped=true&"
var script = {}
import style0 from "./SubMenuContainer.vue?vue&type=style&index=0&id=18d6a3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6a3de",
  null
  
)

export default component.exports